import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './components/App';
import ScrollZone from './components/ScrollZone';
// Authtentication
import LoginPage from './containers/users/LoginPage';
// Users
import ManageUserPage from './containers/users/ManageUserPage';
import UsersPage from './containers/users/UsersPage';
// Events
import EventsPage from './containers/events/EventsPage';
import EventPage from './containers/events/EventPage';
import ViewEvent from './containers/events/ViewEvent';
import ManageEvent from './containers/events/ManageEvent';
// Registration
import RegisterForEvent from './containers/events/register/RegisterForEvent';
import RegisterClub from './containers/events/register/RegisterClub';
import RegSummary from './containers/events/register/RegSummary';
// import ClubInfo from './containers/events/register/ClubInfo';
// Clubs
import ClubsPage from './containers/clubs/ClubsPage';
import ClubPage from './containers/clubs/ClubPage';
import ViewClub from './containers/clubs/ViewClub';
import UploadMembers from './containers/clubs/UploadMembers';
import ManageClubPage from './containers/clubs/ManageClubPage';
// Members
import ManageMemberPage from './containers/clubs/ManageMemberPage';
// reports
import PivotReport from './containers/events/reports/PivotReport';
import ReportsPage from './containers/events/reports/ReportsPage';

// import NotFoundPage from './components/NotFoundPage.js';
// <Route path="*" component={NotFoundPage}/>

function loggedIn() {
  return !!localStorage.token;
}


function requireAuth(nextState, replace) {
  if (!loggedIn()) {
    replace({
      pathname:'/login',
      state: { nextPathname: nextState.location.pathname }
    });
  }
}

export default (
  <Route path="/" component={App}>
    <Route path="/arrangement/:eventId/registrer/klubb/:clubId/oppsummering/print"
      component={RegSummary} onEnter={requireAuth} />

    <Route component={ScrollZone}>
      <Route path="/login"
        component={LoginPage}/>

      <Route path="/bruker/ny"
        onEnter={requireAuth}
        component={ManageUserPage}/>
      <Route path="/bruker/:userId"
        onEnter={requireAuth}
        component={ManageUserPage}/>
      <Route path="/brukere"
        onEnter={requireAuth}
        component={UsersPage}/>

      <Route path="/klubber"
        component={ClubsPage}
        onEnter={requireAuth} />
      <Route path="klubb" component={ClubPage} onEnter={requireAuth}>
        <Route path=":clubId/rediger" component={ManageClubPage} />
        <Route path="ny" component={ManageClubPage} />
        <Route path=":clubId" component={ViewClub} />
        <Route path=":clubId/importer-medlemmer" component={UploadMembers} />
        <Route path=":clubId/medlem/:memberId/rediger" component={ManageMemberPage} />
        <Route path=":clubId/medlem/ny" component={ManageMemberPage}/>
      </Route>

      <Route path="arrangement" component={EventsPage} onEnter={requireAuth} />
      <Route path="arrangement/" component={EventPage} onEnter={requireAuth}>
        <Route path="ny" component={ManageEvent} />
        <Route path=":eventId" component={ViewEvent} />
        <Route path=":eventId/rediger" component={ManageEvent} />
        <Route path=":eventId/rapporter" component={ReportsPage} />
        <Route path=":eventId/rapporter/pivot" component={PivotReport} />
        <Route path=":eventId/registrer" component={RegisterForEvent}>
          <Route path="/arrangement/:eventId/registrer/klubb/:clubId/:stageId"
            component={RegisterClub} />
        </Route>
      </Route>

      <IndexRoute component={EventsPage} onEnter={requireAuth}/>
    </Route>
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/